var _path, _circle, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7855 39.9451C34.0203 43.3029 32.1373 46.9319 29.136 47.7841C26.14 48.6602 22.0309 46.7835 19.8889 43.7254C17.7762 40.6861 17.6253 36.4414 18.5093 32.2993C19.3934 28.1573 21.2884 24.1231 25.0787 21.3386C28.8396 18.5353 34.501 17.0056 39.4608 18.723C44.3911 20.4216 48.6251 25.3913 47.9236 29.4434C47.1928 33.4768 41.5507 36.5874 37.7855 39.9451Z",
    fill: "#FA7B6A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9699,
    cy: 23.9698,
    r: 17.25,
    transform: "rotate(-19.2347 23.9699 23.9698)",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "4 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9688 41.2191C14.4418 41.2191 6.71875 33.496 6.71875 23.9691C6.71875 14.4422 14.4418 6.71912 23.9688 6.71912C29.2933 6.71912 34.0545 9.13158 37.2188 12.9231M37.2188 12.9231L37.7188 10.2191M37.2188 12.9231L34.4543 12.7191",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 13.7191V21.2191",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7188 29.7191L25.7189 25.7191",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7188,
    cy: 23.7191,
    r: 2.25,
    stroke: "#1C1C1C",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobTime.3467546f92e0ed722c6bb51d56e2bad7.svg";